import { apiClient } from './client';

export interface PersonalAccessTokenStatus {
  connected: boolean;
  username?: string | null;
  createdon?: string | null;
}

export class PersonalAccessTokenAPI {
  static async get() {
    return apiClient.get<PersonalAccessTokenStatus>('/personal-access-tokens');
  }

  static async save(token: string) {
    return apiClient.post<PersonalAccessTokenStatus>('/personal-access-tokens', { token });
  }

  static async remove() {
    return apiClient.delete<void>('/personal-access-tokens');
  }
}
